<template>
  <global-window title="添加账号" :visible.sync="dialogVisible" :show="true" width="20%" @confirm="confirmAdd">
    <el-form label-width="100px">
      <el-form-item label="平台">
        <el-select v-model="formData.platform_id" placeholder="请选择" filterable>
          <el-option
            v-for="item in platformSelectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model.trim="formData.account" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="formData.pwd" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.number="formData.remark" />
      </el-form-item>
    </el-form>
  </global-window>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
export default {
  name: 'AddAccountDialog',
  components: {
    GlobalWindow
  },
  props: {
    platformSelectList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        platform_id: null,
        account: null,
        pwd: null,
        remark: null
      },
      selectData: null
    }
  },
  methods: {

    open() {
      this.dialogVisible = true
    },
    confirmAdd() {
      if (this.formData.account === '') {
        this.$message({
          message: '账号不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('emitAddAccount', this.formData)
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
